// Rotating league promo banners — every click goes to FunBet.Me with full tracking.
import { useState, useEffect } from "react";
import { TrendingUp, ChevronRight } from "lucide-react";
import { handleCtaClick } from "../../utils/fbTracking";

const PROMOS = [
  { label: "epl-bets", tag: "PREMIER LEAGUE", title: "EPL Bets — Boosted Odds Every Matchday", cta: "Bet on EPL", grad: "from-purple-700 via-indigo-700 to-blue-700" },
  { label: "ucl-bets", tag: "CHAMPIONS LEAGUE", title: "Champions League Nights — Best Prices, Instant Payouts", cta: "Bet on UCL", grad: "from-blue-800 via-sky-700 to-cyan-700" },
  { label: "laliga-bets", tag: "LA LIGA", title: "La Liga Bets — El Clásico Odds & More", cta: "Bet on La Liga", grad: "from-rose-700 via-red-700 to-orange-700" },
  { label: "seriea-bets", tag: "SERIE A", title: "Serie A Value Picks — Backed by AI Analysis", cta: "Bet on Serie A", grad: "from-emerald-700 via-green-700 to-teal-700" },
  { label: "bundesliga-bets", tag: "BUNDESLIGA", title: "Bundesliga Goals Galore — Over/Under Specials", cta: "Bet on Bundesliga", grad: "from-slate-700 via-slate-800 to-red-900" },
];

const LeaguePromoRotator = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % PROMOS.length), 5000);
    return () => clearInterval(t);
  }, []);
  const p = PROMOS[idx];
  return (
    <button
      onClick={(e) => handleCtaClick(e, p.label)}
      className={`w-full text-left rounded-2xl bg-gradient-to-r ${p.grad} p-4 sm:p-5 flex items-center justify-between gap-4 transition-opacity hover:opacity-95`}
      data-testid="league-promo-rotator"
      data-track="league-promo"
      data-track-text={p.label}
    >
      <div className="min-w-0">
        <div className="text-[10px] font-extrabold uppercase tracking-widest text-white/70 mb-1">{p.tag} · FUNBET.ME</div>
        <div className="text-white font-extrabold text-sm sm:text-lg truncate" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          {p.title}
        </div>
      </div>
      <span className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/15 backdrop-blur text-white text-xs sm:text-sm font-bold whitespace-nowrap">
        <TrendingUp className="w-4 h-4" /> {p.cta} <ChevronRight className="w-4 h-4" />
      </span>
      <div className="absolute bottom-2 right-4 hidden" aria-hidden="true" />
    </button>
  );
};

export default LeaguePromoRotator;
